export const transactionStatus = [{
    value:'I',
    label:'Initiated'
  },{
    value:'A',
    label:'Completed'
  },{
    value:'RA',
    label:'Raised'
  },{
    value:'RM',
    label:'Merchant Raised'
  },{
    value:'R',
    label:'Rejected'
  },{
    value:'M',
    label:'Cancelled'
  },{
    value:'E',
    label:'Expired'
  },{
    value:'F',
    label:'Failed'
  },{
    value:'AA',
    label:'Pending'
  },{
    value:'AR',
    label:'Rejected'
  },{
    value:'RF',
    label:'Refund'
  },{
    value:'C',
    label:'Paid'
  }]

  export const paymentMethods = [{
    value:'1',
    label:'Wallet'
  },{
    value:'2',
    label:'UPI'
  },{
    value:'3',
    label:'QR'
  }] 

  export const transactionType = [{
    value:'PAYIN',
    label:'Payin'
  },{
    value:'PAYOUT',
    label:'Payout'
  }] 

  export const paymentType = [{
    value:'DEPOSIT',
    label:'DEPOSIT'
  },{
    value:'WITHDRAW',
    label:'WITHDRAW'
  }] 
